// Row arrays are immutable, like the arrays used by the table/collection selectors.
const rowCounts = new WeakMap();

/** Missing/null limits are unlimited; deleted rows do not consume capacity. */
const canAddRows = (rows, maxRows) => {
  if (typeof maxRows !== 'number' || !Number.isFinite(maxRows)) return true;

  let rowCount = 0;
  if (Array.isArray(rows)) {
    if (!rowCounts.has(rows)) {
      rowCounts.set(rows, rows.reduce((total, row) => total + (row && !row.deleted ? 1 : 0), 0));
    }
    rowCount = rowCounts.get(rows);
  }

  return rowCount < maxRows;
};

export default canAddRows;
